// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "src_themes_zero-un_js_templates_Default_jsx") return "zero-un/assets/js/chunks/" + chunkId + ".cf8de94343c1c4813b47.js";
	if (chunkId === "src_themes_zero-un_js_templates_NotFound_jsx") return "zero-un/assets/js/chunks/" + chunkId + ".c61bcbb3a2f449beb85f.js";
	if (chunkId === "vendors-node_modules_css-loader_dist_runtime_api_js-node_modules_css-loader_dist_runtime_sour-8a000c") return "zero-un/assets/js/chunks/" + chunkId + ".fa71ed1298a4bb6e1102.js";
	if (chunkId === "src_themes_zero-un_js_templates_LegalPage_jsx") return "zero-un/assets/js/chunks/" + chunkId + ".ceeca6da2ff15ed222ef.js";
	// return url for filenames based on template
	return undefined;
};